import Layout from '../../internal/Layout.vue'
import electricalSafety from './index.vue'
import ElectricalSafetyManage from './ElectricalSafetyManage/ElectricalSafetyManage.vue'
import electricalSafetyPreview from './components/electricalSafetyPreview.vue'

const electricalSafetyRoutes = {
  component: Layout,
  children: [
    {
      name: 'electricalSafety',
      path: '/',
      component: electricalSafety,
      meta: {
        module: 'calibracao',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
      },
    },
    {
      name: 'formElectricalSafety',
      path: '/formElectricalSafety',
      component: ElectricalSafetyManage,
      meta: {
        module: 'calibracao',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: false,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
    {
      name: 'ElectricalSafetyPreview',
      path: '/electrical-safety-preview/:id',
      component: electricalSafetyPreview,
      meta: {
        module: 'calibracao',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: false,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
  ],
}

export default electricalSafetyRoutes
